import { UrlObject } from "url";
import { ROUTES } from "@nf/constants";
import { useRoutePathBuild, useRouterDefinedParams } from "../../../hooks";
import { useMemo } from "react";

export const useRouterRedirectionParams = (): UrlObject | undefined => {
  const routePrefix = useRoutePathBuild();

  const { redirectParam, noCodeParam, redirectUrlParam } =
    useRouterDefinedParams();

  return useMemo(() => {
    if (redirectParam) {
      const redirectCode = redirectParam?.slice(-6);
      return {
        pathname: `${routePrefix}${ROUTES.TV_CODE_LOGIN}`,
        query: {
          code: redirectCode,
        },
      };
    }

    if (noCodeParam) {
      return {
        pathname: `${routePrefix}${ROUTES.TV_CODE_LOGIN}`,
      };
    }

    if (redirectUrlParam) {
      return {
        pathname: `${routePrefix}${redirectUrlParam}`,
      };
    }

    return undefined;
  }, [redirectParam, noCodeParam, redirectUrlParam, routePrefix]);
};
